class CollectionNav extends HTMLElement {
    constructor(props) {
        super();
        this.bindEvents();
        this.init();
    }

    init(){
        this.checkMobileNavScroll();
        this.showCollectionOnScroll();
    }

    checkMobileNavScroll(){
        if($(window).width() <= 768) {
            let pos = $('.collection-nav__item.active').position();

            if (pos){
                $('.collection-nav__tab-content.active').scrollLeft(pos.left - 150);
                $('.collection-nav__tab-content.mobile-active-always').scrollLeft(pos.left - 150);
            }
        }
    }

    showCollectionOnScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let collectionNav = document.querySelector('.collection-nav-section');
        if(collectionNav && (window.innerWidth < 481)){
            let position_nav = 42;
            if(scrollTop < 45){
                position_nav = 80 - scrollTop
            }
            collectionNav.style.top = position_nav + 'px';

            let body_content = document.querySelector('#MainContent');
            body_content.style.paddingTop = '126px';
        }
    }

    bindEvents() {
        $('.collection-nav__tab-item').bind('click', this.onCollectionNavTabClick.bind(this));
        $('.collection-nav__tab-mob-active').bind('click', this.onMobileNavTabClick.bind(this));
        $('.collection-nav__item').bind('click', this.onCollectionNavItemClick.bind(this));
    }

    onCollectionNavTabClick(event) {
        const collectionTab = $(event.target);
        const collectionTabTitle = collectionTab.data('title');
        const collectionTitle = collectionTab.text();

        $('.collection-nav__tab-item').not(this).removeClass('active');
        collectionTab.addClass('active');

        $('.collection-nav__tab-content').removeClass('active');
        $('.collection-nav__tab-content[data-title="'+collectionTabTitle+'"]').addClass('active');

        if ($(window).width() <= 749) {
            $('.collection-nav__tab-mob-list').removeClass('active');
            $('.collection-nav__tab-mob-active').removeClass('active');
            $('.collection-nav__tab-mob-active span').text(collectionTitle);
        }
    }

    onMobileNavTabClick(event) {
        $(event.target).closest('.collection-nav__tab-mob').find('.collection-nav__tab-mob-list').toggleClass('active');
        $(event.target).closest('.collection-nav__tab-mob').find('.collection-nav__tab-mob-active').toggleClass('active');
    }

    onCollectionNavItemClick(event) {
        const eventTarget = $(event.target);
        const collectionItem = (eventTarget.hasClass('collection-nav__item')) ? eventTarget : eventTarget.parent();
        const collectionURL = collectionItem.data('url');
        const currentURL = window.location.href;
        const activeTab = $('.collection-nav__tab-content.active').data('title');

        if (currentURL.indexOf(collectionURL) < 0) {
            this.getPageAjax(collectionURL, activeTab);
        }
    }

    getPageAjax(collectionURL, activeTab) {
        const _this = this;

        $.ajax({
            url: collectionURL,
            type: 'GET'
        }).done(function(response) {
            let mainContentNew = $($.parseHTML(response)).find('#MainContent');
            let pageTitle = $(response).filter('title').text().trim();

            _this.changeLocation(response, pageTitle, collectionURL);
            $('#MainContent').html(mainContentNew);

            if ($('.collection-nav__tab-content').length > 0) {
                $('.collection-nav__tab-item').not(this).removeClass('active');
                $('.collection-nav__tab-item[data-title="' + activeTab + '"]').addClass('active');
                $('.collection-nav__tab-content').removeClass('active');
                $('.collection-nav__tab-content[data-title="' + activeTab + '"]').addClass('active');
                $('.collection-nav__tab-mob-active span').text(activeTab);

                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }

        });
    }

    changeLocation(response, title, urlPath){
        window.history.pushState(null, null, urlPath);
        document.title = title;
    }
}

window.onpopstate = function(e){
    location.reload();
};

customElements.define('collection-nav', CollectionNav);